import { render } from "./ElectionScheduleDetails.vue?vue&type=template&id=376f17b9&scoped=true"
import script from "./ElectionScheduleDetails.vue?vue&type=script&lang=js"
export * from "./ElectionScheduleDetails.vue?vue&type=script&lang=js"

import "./ElectionScheduleDetails.vue?vue&type=style&index=0&id=376f17b9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376f17b9"]])

export default __exports__